var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgActionAdd = function SvgActionAdd(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C8.35655 14 8.6544 13.7219 8.6544 13.3794V8.64083H13.3517C13.7013 8.64083 14 8.34897 14 7.99959C13.9982 7.83183 13.9292 7.67147 13.808 7.553C13.6868 7.43453 13.5229 7.36741 13.3517 7.36607H8.6544V2.61981C8.6544 2.27816 8.35655 2.00003 8 2.00003C7.83037 1.99842 7.66701 2.06274 7.54567 2.17891C7.42434 2.29507 7.35492 2.45361 7.35261 2.61981V7.36607H2.64827C2.47706 7.36741 2.31323 7.43453 2.192 7.553C2.07077 7.67147 2.00183 7.83183 2 7.99959C2 8.34897 2.29873 8.64083 2.64827 8.64083H7.35261V13.3794C7.35261 13.7219 7.64345 14 8 14Z",
    fill: "white"
  })));
};
export default SvgActionAdd;